import React from 'react';
import { useTranslation } from 'react-i18next';

import AlignmentWrapper from 'formlabs-web-components/Wrapper/AlignmentWrapper';

import ContactSales from '../../../../components/content/ContactSales';

const ContactSalesBlock = () => {
  const [t] = useTranslation();
  return (
    <AlignmentWrapper alignment="center" width={24}>
      <p>{t('Have questions about configuring your Fuse 1 ecosystem?')}</p>
      <ContactSales
        linkText={t('Contact Sales')}
        buttonColor="borderless-blue"
        buttonArrow="right-caret"
      />
    </AlignmentWrapper>
  );
};

export default ContactSalesBlock;
